import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react"

import { RootState } from "../store"

export const leaderboardApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_APP_API_URL}/${import.meta.env.VITE_APP_API_VERSION}`,
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState
      const authToken = state.auth.masquerade_access_token || state.auth.api_access_token
      const tokenType = state.auth.token_type
      headers.set("Content-Type", "application/json")
      headers.set("Accept", "application/json")
      if (authToken) {
        headers.set("authorization", `${tokenType} ${authToken}`)
      }
      return headers
    },
  }),

  reducerPath: "leaderboardApi",
  tagTypes: ["Leaderboard", "LeaderboardDropDown"],

  endpoints: (builder) => ({
    getGlobalLeaderBoars: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/metrics/rank",
        method: "POST",
        body: payload,
      }),
    }),
    getSkills: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/skills",
        method: "POST",
      }),
    }),
    getJobTitles: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/job_titles",
        method: "POST",
      }),
    }),
    getDepartment: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/departments",
        method: "POST",
      }),
    }),
    getRegions: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/regions",
        method: "POST",
      }),
    }),
    getServiceTeams: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/service_teams",
        method: "POST",
      }),
    }),
    getDiscoveryTeams: builder.mutation<any, void>({
      query: () => ({
        url: "users/attributes/discovery_teams",
        method: "POST",
      }),
    }),
    getWidgetData: builder.mutation<any, any>({
      query: (payload) => ({
        url: "/metrics/rank/widget",
        method: "POST",
        body: payload,
      }),
    }),
    leaderboard: builder.mutation<API.Response.LeaderboardResponse, API.Payload.LeaderboardPayload>({
      query: (payload) => ({
        url: "metrics/rank",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["Leaderboard"],
    }),
  }),
})

export const {
  useGetDepartmentMutation,
  useGetDiscoveryTeamsMutation,
  useGetGlobalLeaderBoarsMutation,
  useGetJobTitlesMutation,
  useGetRegionsMutation,
  useGetServiceTeamsMutation,
  useGetSkillsMutation,
  useGetWidgetDataMutation,
  useLeaderboardMutation,
} = leaderboardApi
